import ExpoCapacitorStorage from './src/ExpoCapacitorStorageModule';

/**
 * Clear all keys from storage
 */
export function clear() {
  try {
    ExpoCapacitorStorage.clear();
  } catch (error) {
    throw new Error(error as string);
  }
}

/**
 * Gets a key
 */
export function get(key: string) {
  if (!key) {
    throw new Error('Must provide key');
  }

  try {
    const value = ExpoCapacitorStorage.get(key);
    // NOTE: Returning inside a `value` key was on the native layer previously.
    return { value };
  } catch (error) {
    throw new Error(error as string);
  }
}

/**
 * Set a key
 */
export function set(key: string, value: string | null) {
  if (!key) {
    throw new Error('Must provide key');
  }

  try {
    return ExpoCapacitorStorage.set(key, value ?? '');
  } catch (error) {
    throw new Error(error as string);
  }
}

/**
 * Remove a key
 */
export function remove(key: string) {
  if (!key) {
    throw new Error('Must provide key');
  }

  try {
    return ExpoCapacitorStorage.remove(key);
  } catch (error) {
    throw new Error(error as string);
  }
}

/**
 * Get all keys
 */
export function keys() {
  try {
    const keys = ExpoCapacitorStorage.keys() as string[];

    // NOTE: Returning inside a `keys` key was on the native layer previously.
    return { keys };
  } catch (error) {
    throw new Error(error as string);
  }
}
